import React, { useState } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";
import { NotificationManager } from "react-notifications";

import StarRating from "../../../../sharedComponents/starRating";
import { FormField } from "../../../../sharedComponents/formField";
import { required } from "../../../../constants/formValidators";

import { addRecipeComment } from "../../../../store/actions";

const RecipeCreateComment = ({ handleSubmit, resetForm, addRecipeComment, recipeId, form }) => {
	const [star, updateStar] = useState(0);

	const validateForm = (values) => {
		const apiValues = { ...values, rating: star, recipe: recipeId };
		const successHandler = (event) => {
			if (event && event.status >= 200 && event.status < 300) {
				event.json().then((data) => {
					NotificationManager.success("Your comment will be visible after approval.", "", 5000);
				});
			}
		};
		resetForm(form);
		addRecipeComment(apiValues, successHandler);
	};

	return (
		<form onSubmit={handleSubmit(validateForm)} className="block-section create-comment">
			<h4 className="title-primary-dark border-bottom-default pb-2">Leave your comments</h4>
			<div className="row">
				<div className="form-group col-8">
					<label className="form-label m-0">Rating</label>
					<StarRating theme="dark" value={star} onUpdate={(event) => updateStar(event * 2)} />
				</div>
			</div>
			<div className="row">
				<Field
					label="Headline"
					name="title"
					type="text"
					formGroupClass="col-8"
					component={FormField}
					validate={[required]}
				/>
			</div>
			<div className="row">
				<Field
					label="Comment"
					name="notes"
					type="textarea"
					formGroupClass="col-12"
					component={FormField}
					validate={[required]}
				/>
			</div>
			<div className="text-right">
				<button type="button" onClick={() => resetForm(form)} className="btn btn-default">
					Cancel
				</button>
				<button type="submit" className="btn btn-primary">
					Comment
				</button>
			</div>
		</form>
	);
};

const mapDispatchToProps = { addRecipeComment, resetForm: reset };

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "RecipeCreateCommentForm",
		enableReinitialize: true
	})(RecipeCreateComment)
);
